import { StyleSheet, Platform, Dimensions } from 'react-native';
const ls = StyleSheet.create({
  container: {
    marginHorizontal: 16,
    marginTop: 24,
  },
  heading: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'white',
    borderWidth: 1,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomWidth: 0,
    borderColor: '#E4E7EC',
    elevation: 20,
    shadowColor: '#98A2B3',
    zIndex: 1,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4.65,
  },
  coinImage: {
    height: 87,
    width: 70,
  },
  coinImageContainer: {
    paddingLeft: 12,
    marginRight: 4,
    paddingBottom: 21,
    marginTop: -10,
  },
  textHeading: {
    paddingVertical: 24,
    marginHorizontal: 4,
    flexShrink: 1,
  },
  subHeading: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#E4E7EC',
    flex: 1,
  },
  subHeadingWithPadding: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#E4E7EC',
    flex: 1,
    paddingBottom: 24,
  },
  buttonElevation: {
    elevation: 24,
    paddingTop: 16,
    paddingHorizontal: 12,
  },
  frameButtonContainer: {
    elevation: 24,
    shadowColor: '#1434CB',
    ...(Platform.OS === 'ios' && {
      shadowOffset: { width: 0, height: 16 },
      shadowOpacity: 0.25,
      shadowRadius: 12,
    }),
    flexDirection: 'row',
    marginHorizontal: Dimensions.get('screen').width > 450 ? 16 : 0,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    ...(Platform.OS === 'web' && {
      boxShadow: '0 16px 24px 0 rgba(20, 52, 203, 0.25)',
    }),
  },
  signImg: {
    height: 12,
    width: 13,
  },
  signContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  signImageContainer: {
    paddingBottom: 23,
    marginTop: 11,
  },
  creditText: {
    paddingBottom: 20,
    marginTop: 8,
    marginLeft: 4,
  },
  text: {
    marginBottom: 4,
  },
  iconContainer: {
    paddingVertical: 12,
    justifyContent: 'center',
  },
  eligibleText: {
    paddingVertical: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  instaStoryContainer: {
    marginLeft: 12,
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
    ...Platform.OS === 'ios'
    && {
        flex: 1,
        justifyContent: 'space-between',
        width: Dimensions.get('window').width,
      },
  },
  wrapper: {
      width: Dimensions.get('window').width / 5,
      borderColor: 'transparent',
  },
  storyText: {
      width: Platform.OS === 'ios'
          ? Dimensions.get('window').width / 6
          : Dimensions.get('window').width / 7,
      marginLeft: Platform.OS === 'ios' ? 10 : 12,
      ...Platform.OS === 'ios'
      && {
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
      },
      alignItems: 'center',
      color: '#667085'
  },
  storyImageStyle: {
      resizeMode: 'stretch',
  },
});

export default ls;
